/* =====================================================================
   NFL MUNICH GAME 2026 — Thème Shopify : comportements globaux
   header · méga-menu · menu mobile · compte à rebours · panier (API Cart
   AJAX Shopify, plafond de commande silencieux, réservation 15 min) ·
   boîte d'achat simple · page panier · toast · CTA mobile · apparitions.
   Aucune dépendance, chargé en defer.
   ===================================================================== */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const CFG = window.MG_CFG || {};
  const T = window.MG_T || {};
  const R = CFG.routes || {};
  const MG = (window.MG = window.MG || {});

  const fill = (s, vars) => String(s == null ? '' : s).replace(/\{(\w+)\}/g, (m, k) => (vars && k in vars ? vars[k] : m));
  MG.t = (k, vars) => fill(T[k] != null ? T[k] : k, vars);
  const nf = new Intl.NumberFormat(CFG.locale === 'en' ? 'en-IE' : 'de-DE', { style: 'currency', currency: CFG.currency || 'EUR', maximumFractionDigits: 0 });
  MG.money = (v) => nf.format(v);
  MG.plural = (n) => (n === 1 ? T.ticket_one : T.ticket_other) || '';

  /* ---------- Header ---------- */
  function header() {
    const h = $('[data-header]');
    if (!h) return;
    let last = window.scrollY, ticking = false;
    const update = () => {
      const y = window.scrollY;
      h.classList.toggle('is-scrolled', y > 40);
      const busy = document.documentElement.classList.contains('menu-open') || $('.nav__item.is-open', h);
      if (!busy && y > 400 && y > last + 6) h.classList.add('is-hidden');
      else if (y < last - 6 || y < 400) h.classList.remove('is-hidden');
      last = y; ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
    $$('[data-mega]', h).forEach((item) => {
      const link = $('.nav__link', item);
      link.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) { e.preventDefault(); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); }
      });
      item.addEventListener('mouseenter', () => link.setAttribute('aria-expanded', 'true'));
      item.addEventListener('mouseleave', () => { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); });
      item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { item.classList.remove('is-open'); link.focus(); } });
    });
    document.addEventListener('click', (e) => { $$('.nav__item.is-open').forEach((i) => { if (!i.contains(e.target)) i.classList.remove('is-open'); }); });
  }

  /* ---------- Menu mobile ---------- */
  // Rideau sous l'en-tête : l'en-tête ne bouge pas (pas de saut), le menu se replie d'un seul bloc à la fermeture.
  function mobileMenu() {
    const btn = $('[data-menu-toggle]'), menu = $('#mobile-menu'), h = $('[data-header]');
    if (!btn || !menu) return;
    const root = document.documentElement;
    const set = (open) => {
      if (open && h) {
        h.classList.remove('is-hidden');
        menu.style.setProperty('--menu-top', Math.max(0, Math.round(h.getBoundingClientRect().bottom)) + 'px');
      }
      menu.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
      btn.setAttribute('aria-label', open ? btn.dataset.labelClose : btn.dataset.labelOpen);
      root.classList.toggle('menu-open', open);
    };
    btn.addEventListener('click', () => set(!menu.classList.contains('is-open')));
    $$('a', menu).forEach((a) => a.addEventListener('click', () => set(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menu.classList.contains('is-open')) { set(false); btn.focus(); } });
    window.matchMedia('(min-width: 1101px)').addEventListener('change', (m) => { if (m.matches) set(false); });
  }

  /* ---------- Compte à rebours ---------- */
  function countdown() {
    const target = new Date(CFG.kickoff || '2026-11-15T15:30:00+01:00').getTime();
    const tick = () => {
      let r = Math.max(0, target - Date.now());
      const d = Math.floor(r / 864e5); r -= d * 864e5;
      const h = Math.floor(r / 36e5); r -= h * 36e5;
      const m = Math.floor(r / 6e4); r -= m * 6e4;
      const s = Math.floor(r / 1e3);
      const txt = target <= Date.now() ? MG.t('live') : fill(T.countdown, { d: d, h: h, m: String(m).padStart(2, '0') });
      $$('[data-countdown-text]').forEach((el) => { el.textContent = txt; });
      const parts = { days: d, hours: h, minutes: m, seconds: s };
      $$('[data-countdown] [data-unit]').forEach((el) => { el.textContent = String(parts[el.dataset.unit]).padStart(2, '0'); });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Toast ---------- */
  let toastT;
  MG.toast = (text, actionLabel, action) => {
    const t = $('[data-toast]');
    if (!t) return;
    t.textContent = text;
    if (actionLabel) {
      const b = document.createElement('button');
      b.type = 'button'; b.textContent = actionLabel;
      b.addEventListener('click', () => { t.classList.remove('is-visible'); if (action) action(); });
      t.appendChild(b);
    }
    t.classList.add('is-visible');
    clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove('is-visible'), 4000);
  };

  /* ---------- Panier : API Cart AJAX de Shopify ---------- */
  // Plafond interne (CAP €, jamais affiché) : billets, hospitality et expériences. Les add-ons (parking, kit)
  // n'ont que leur limite produit (metafield mg26.max_per_order, transmis en propriété cachée _max).
  const CAP = Number(CFG.orderCap) || 850;
  const HOLD_MS = (Number(CFG.holdMinutes) || 15) * 60000;
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { /* stockage indisponible */ } },
  };
  const holdUntil = () => Number(store.get('mg-hold-until')) || 0;
  const json = (url, body) => fetch(url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined })
    .then(async (r) => { const data = await r.json().catch(() => ({})); if (!r.ok) throw new Error(data.description || data.message || 'cart'); return data; });
  const route = (k, fallback) => (R[k] || fallback);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const capped = (type) => type !== 'Add-on';
  const isTicket = (type) => type === 'Ticket' || type === 'Hospitality';
  MG.esc = esc;
  MG.isTicket = isTicket;

  MG.cart = {
    state: { items: [] },
    normalize(c) {
      return {
        items: (c.items || []).map((i) => {
          const p = i.properties || {};
          return {
            id: i.variant_id, key: i.key, title: i.product_title,
            variant: i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '',
            price: i.final_price / 100, qty: i.quantity, url: i.url, image: i.image, type: i.product_type || '',
            color: p._color || (CFG.typeColors || {})[i.product_type] || '#0076B6',
            max: Number(p._max) || 0, tier: p._tier || '', side: p._side || '', together: p._together === '1',
          };
        }),
      };
    },
    count() { return this.state.items.reduce((s, i) => s + i.qty, 0); },
    total() { return this.state.items.reduce((s, i) => s + i.qty * i.price, 0); },
    totalExcept(id) { return this.state.items.filter((i) => i.id !== id && capped(i.type)).reduce((s, i) => s + i.qty * i.price, 0); },
    // « max. n pro Bestellung » : limite produit et plafond, sans tenir compte du reste du panier
    perOrder(o) {
      const n = Math.min(capped(o.type) ? Math.floor(CAP / o.price) : Infinity, o.max || Infinity);
      return Math.max(1, n === Infinity ? 10 : n);
    },
    // Quantité totale possible pour cette variante compte tenu du reste du panier
    limit(o) {
      let n = this.perOrder(o);
      if (capped(o.type)) n = Math.min(n, Math.floor((CAP - this.totalExcept(o.id)) / o.price));
      return Math.max(0, n);
    },
    qtyOf(id) { return this.state.items.filter((i) => i.id === id).reduce((s, i) => s + i.qty, 0); },
    emit() { document.dispatchEvent(new CustomEvent('mg:cart', { detail: this.state })); },
    async refresh() { this.state = this.normalize(await json(route('cart', '/cart') + '.js')); if (!this.state.items.length) store.set('mg-hold-until', null); this.emit(); return this.state; },
    // item : { id (variante), qty, price (€), type, max, color, tier, side, together (places côte à côte) }
    async add(item) {
      await this.ready;
      const current = this.qtyOf(item.id);
      const delta = Math.min(current + item.qty, this.limit(item)) - current;
      if (delta <= 0) return 0;
      const props = {};
      if (item.color) props._color = item.color;
      if (item.max) props._max = String(item.max);
      if (item.tier) props._tier = item.tier;
      if (item.side) props._side = item.side;
      if (item.together) props._together = '1';
      await json(route('cartAdd', '/cart/add') + '.js', { items: [{ id: item.id, quantity: delta, properties: Object.keys(props).length ? props : undefined }] });
      if (holdUntil() < Date.now()) store.set('mg-hold-until', String(Date.now() + HOLD_MS));
      await this.refresh();
      return delta;
    },
    async setQty(key, q) {
      const it = this.state.items.find((i) => i.key === key);
      if (!it) return 0;
      const qty = Math.max(0, Math.min(q, this.limit(it)));
      await json(route('cartChange', '/cart/change') + '.js', { id: key, quantity: qty });
      await this.refresh();
      return qty;
    },
    async clear() { await json(route('cartClear', '/cart/clear') + '.js', {}); store.set('mg-hold-until', null); await this.refresh(); },
  };
  MG.cart.ready = MG.cart.refresh().catch(() => MG.cart.state);

  /* Talon de billet (tiroir) : bloc en grand sur la couleur de la catégorie, sinon vignette produit */
  function stub(i) {
    const block = /^\d+$/.test(i.variant);
    const ticket = isTicket(i.type);
    const side = i.side ? ((T.sides && T.sides[i.side]) || i.side) : '';
    const meta = block ? [i.tier, side].filter(Boolean).join(' · ') : i.variant;
    const img = i.image ? esc(i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=160') : '';
    const full = i.qty + 1 > MG.cart.limit(i);
    return '<article class="stub' + (block ? ' stub--block' : '') + '" style="--cat:' + esc(i.color) + '">' +
      '<div class="stub__tab">' + (block
        ? '<small>' + esc(T.block) + '</small><strong>' + esc(i.variant) + '</strong>'
        : img ? '<img src="' + img + '" alt="" width="80" height="80" loading="lazy">' : '<svg aria-hidden="true"><use href="#i-ticket"/></svg>') +
      '</div>' +
      '<div class="stub__body">' +
        '<a class="stub__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
        '<p class="stub__meta">' + (meta ? esc(meta) + ' · ' : '') + MG.money(i.price) + ' ' + esc(ticket ? T.per_ticket : T.per_item) + '</p>' +
        (i.together && i.qty > 1 ? '<span class="stub__tag"><svg aria-hidden="true"><use href="#i-check"/></svg>' + esc(T.together_tag) + '</span>' : '') +
        '<div class="stub__row">' +
          '<div class="qty qty--sm" role="group" aria-label="' + esc(i.title) + '">' +
            '<button type="button" data-qty-key="' + esc(i.key) + '" data-step="-1" aria-label="' + esc(ticket ? T.remove_one : T.less_one) + '"><svg aria-hidden="true"><use href="#i-minus"/></svg></button>' +
            '<span>' + i.qty + '</span>' +
            '<button type="button" data-qty-key="' + esc(i.key) + '" data-step="1" aria-label="' + esc(ticket ? T.add_one : T.more_one) + '"' + (full ? ' disabled' : '') + '><svg aria-hidden="true"><use href="#i-plus"/></svg></button>' +
          '</div>' +
          '<button type="button" class="stub__remove" data-qty-key="' + esc(i.key) + '" data-set="0">' + esc(T.remove) + '</button>' +
          '<strong class="stub__price">' + MG.money(i.price * i.qty) + '</strong>' +
        '</div>' +
      '</div>' +
    '</article>';
  }

  // Réservation : temps restant et barre, partout où un bloc [data-hold] existe (tiroir, page panier)
  function paintHold() {
    const until = holdUntil(), has = MG.cart.state.items.length > 0;
    const left = Math.max(0, until - Date.now());
    const m = Math.floor(left / 6e4), s = Math.floor((left % 6e4) / 1e3);
    $$('[data-hold]').forEach((h) => { h.hidden = !has || !until; h.classList.toggle('is-urgent', left < 3 * 6e4); });
    $$('[data-hold-time]').forEach((el) => { el.textContent = m + ':' + String(s).padStart(2, '0'); });
    $$('[data-hold-bar]').forEach((el) => { el.style.transform = 'scaleX(' + Math.min(1, left / HOLD_MS).toFixed(4) + ')'; });
  }

  // Suggestions : on masque ce qui est déjà dans le panier, et la section si tout y est
  function paintUpsell() {
    const ids = MG.cart.state.items.map((i) => String(i.id));
    $$('[data-upsell-item]').forEach((li) => { li.hidden = ids.indexOf(li.dataset.upsellItem) > -1; });
    $$('[data-upsell]').forEach((sec) => { sec.hidden = !$$('[data-upsell-item]', sec).some((li) => !li.hidden); });
  }

  function cartUI() {
    const drawer = $('[data-drawer]');
    if (!drawer) return;
    const items = $('[data-cart-items]', drawer), empty = $('[data-cart-empty]', drawer), foot = $('[data-cart-foot]', drawer), upsell = $('[data-cart-upsell]', drawer);
    let lastFocus = null;
    const open = () => { lastFocus = document.activeElement; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; setTimeout(() => { const b = $('.drawer__close', drawer); if (b) b.focus(); }, 60); };
    const close = () => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); };
    MG.openCart = open;
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-cart-open]');
      if (opener && !document.body.matches('[data-template="cart"]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-cart-close]')) close();
      const q = e.target.closest('[data-qty-key]');
      if (q && !q.disabled && drawer.contains(q)) {
        const it = MG.cart.state.items.find((i) => i.key === q.dataset.qtyKey);
        if (!it) return;
        const target = q.dataset.set != null ? Number(q.dataset.set) : it.qty + Number(q.dataset.step);
        q.disabled = true;
        MG.cart.setQty(it.key, target).catch(() => MG.toast(MG.t('error')));
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

    const paint = () => {
      const st = MG.cart.state, n = MG.cart.count(), has = st.items.length > 0;
      $$('[data-cart-count]').forEach((b) => { b.textContent = n; b.hidden = !n; });
      $$('[data-cart-count-label]').forEach((b) => { b.textContent = has ? '(' + MG.t(n === 1 ? 'item_one' : 'item_other', { n: n }) + ')' : ''; });
      $$('[data-cart-count-short]').forEach((b) => { b.textContent = has ? MG.t(n === 1 ? 'item_one' : 'item_other', { n: n }) + ' · ' : ''; });
      empty.hidden = has; foot.hidden = !has; upsell.hidden = !has;
      const total = $('[data-cart-total]', drawer);
      if (total) total.textContent = MG.money(MG.cart.total());
      items.innerHTML = st.items.map(stub).join('');
      paintUpsell();
      paintHold();
    };
    document.addEventListener('mg:cart', paint);

    // Réservation des places (concept billetterie) : au-delà du délai, le panier est vidé
    setInterval(() => {
      if (!MG.cart.state.items.length || !holdUntil()) return;
      if (holdUntil() <= Date.now()) {
        store.set('mg-hold-until', null);
        MG.cart.clear().then(() => { MG.toast(MG.t('expired')); if (document.body.matches('[data-template="cart"]')) window.location.reload(); }).catch(() => {});
        return;
      }
      paintHold();
    }, 1000);
  }

  /* ---------- Ajout en un clic (suggestions du panier, cartes produits) ---------- */
  function quickAdd() {
    document.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-quick-add]');
      if (!b || b.disabled) return;
      e.preventDefault();
      b.disabled = true; b.classList.add('is-busy');
      try {
        const added = await MG.cart.add({ id: Number(b.dataset.quickAdd), qty: 1, price: Number(b.dataset.price), type: b.dataset.type || '', max: Number(b.dataset.max) || 0, color: b.dataset.color });
        if (!added) MG.toast(MG.t('limit_toast'));
        else {
          document.dispatchEvent(new CustomEvent('mg:quick-added', { detail: { button: b } }));
          if (!b.closest('[data-drawer]') && !document.body.matches('[data-template="cart"]') && MG.openCart) MG.openCart();
        }
      } catch (err) { MG.toast(err.message || MG.t('error')); }
      b.disabled = false; b.classList.remove('is-busy');
    });
  }

  /* ---------- Boîte d'achat simple (produits hors plan) ---------- */
  function buySimple() {
    $$('[data-buy-simple]').forEach((box) => {
      const sel = $('[data-variant]', box), out = $('[data-qty]', box), total = $('[data-total]', box), limit = $('[data-limit]', box), add = $('[data-add]', box);
      const recap = $('[data-recap]', box), tg = $('[data-together-wrap]', box), addLabel = $('.btn__label', add) || add;
      let qty = 1;
      const type = box.dataset.type || '';
      const price = () => (sel && sel.tagName === 'SELECT' ? Number(sel.selectedOptions[0].dataset.price) : Number(box.dataset.price)) || 0;
      const vid = () => Number(sel.value);
      const item = () => ({ id: vid(), price: price(), type: type, max: Number(box.dataset.max) || 0, color: box.dataset.color });
      const max = () => Math.max(0, MG.cart.limit(item()) - MG.cart.qtyOf(vid()));
      const update = () => {
        const m = max();
        qty = Math.max(1, Math.min(qty, m || 1));
        out.textContent = m ? qty : 0;
        $('[data-step="-1"]', box).disabled = qty <= 1 || !m;
        $('[data-step="1"]', box).disabled = qty >= m;
        total.textContent = MG.money(qty * price());
        if (recap) recap.textContent = (m ? qty : 0) + ' × ' + MG.money(price());
        if (tg) { tg.hidden = !m || qty < 2; $('[data-together-text]', tg).textContent = MG.t('together_text_simple', { n: qty }); }
        limit.textContent = MG.t(isTicket(type) ? 'limit' : 'limit_items', { n: MG.cart.perOrder(item()) });
        if (!add.hasAttribute('data-soldout')) { add.disabled = !m; addLabel.textContent = m ? MG.t('add') : MG.t('limit_reached'); }
      };
      if (add.disabled) add.setAttribute('data-soldout', '');
      box.addEventListener('click', (e) => {
        const st = e.target.closest('[data-step]');
        if (st && !st.disabled) { qty += Number(st.dataset.step); update(); }
      });
      if (sel && sel.tagName === 'SELECT') sel.addEventListener('change', () => { qty = 1; update(); });
      add.addEventListener('click', async () => {
        add.disabled = true;
        try {
          const added = await MG.cart.add(Object.assign(item(), { qty: qty, together: !!(tg && $('[data-together]', tg).checked) }));
          if (!added) MG.toast(MG.t('limit_toast')); else MG.openCart();
        } catch (err) { MG.toast(err.message || MG.t('error')); }
        update();
      });
      document.addEventListener('mg:cart', update);
      update();
    });
  }

  /* ---------- Page panier : quantités et suggestions sans rechargement (Section Rendering API) ---------- */
  function cartPage() {
    if (!$('[data-cart-page]')) return;
    let busy = false, again = false;
    const rerender = async () => {
      const cur = $('[data-cart-page]');
      if (!cur) return;
      if (busy) { again = true; return; }
      busy = true;
      try {
        const html = await (await fetch(window.location.pathname + '?section_id=' + encodeURIComponent(cur.dataset.sectionId))).text();
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-page]');
        if (next) { cur.replaceWith(next); paintHold(); paintUpsell(); } else window.location.reload();
      } catch (e) { window.location.reload(); }
      busy = false;
      if (again) { again = false; rerender(); }
    };
    // Liens −/+ et « Entfernen » : fonctionnent sans JS (/cart/change?line=…), interceptés ici
    document.addEventListener('click', async (e) => {
      const a = e.target.closest('[data-line-qty]');
      if (!a || !a.closest('[data-cart-page]')) return;
      e.preventDefault();
      if (a.getAttribute('aria-disabled') === 'true') { MG.toast(MG.t('limit_toast')); return; }
      a.closest('.cart-item').classList.add('is-busy');
      await MG.cart.ready;
      try {
        const wanted = Number(a.dataset.qty);
        const got = await MG.cart.setQty(a.dataset.key, wanted);
        if (got < wanted) MG.toast(MG.t('limit_toast'));
      } catch (err) { MG.toast(MG.t('error')); }
      rerender();
    });
    document.addEventListener('mg:quick-added', rerender);
  }

  /* ---------- CTA mobile collant (accueil) ---------- */
  function stickyCta() {
    const bar = $('[data-sticky-cta]');
    if (!bar || !('IntersectionObserver' in window)) return;
    const vis = new Map();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => vis.set(e.target, e.isIntersecting));
      bar.classList.toggle('is-visible', !Array.from(vis.values()).some(Boolean));
    });
    $$('[data-hero], [data-hide-sticky], #billets, .site-footer').forEach((el) => io.observe(el));
  }

  /* ---------- Apparitions discrètes ---------- */
  function reveals() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const els = $$('.section-head, .team, .tape, .player, .access, .hosp__content, .trust li, .p-card');
    els.forEach((el) => { el.setAttribute('data-reveal', ''); el.style.setProperty('--i', Math.min(Array.from(el.parentElement.children).indexOf(el), 6)); });
    const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });
    els.forEach((el) => io.observe(el));
  }

  function init() {
    header(); mobileMenu(); countdown(); cartUI(); quickAdd(); buySimple(); cartPage(); stickyCta(); reveals();
    document.dispatchEvent(new CustomEvent('mg:ready'));
    MG.isReady = true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
